"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var logger_1 = require("./util/logger");
var vf_tools_1 = require("./util/vf-tools");
var VFModel = (function () {
    function VFModel(meshList, webScene, modelFileSize, version) {
        var e_1, _a;
        if (webScene === void 0) { webScene = null; }
        this.meshList = meshList;
        this.webScene = webScene;
        this.modelFileSize = modelFileSize;
        this.scaleFactor = 1.0;
        this._objectsByPath = {};
        this._materialsByName = {};
        this.root = meshList.find(function (mesh) { return mesh.parent == null; });
        this.contentRoot = this.root.getChildTransformNodes(true)[0];
        this.version = version;
        this.format = "glb";
        if (this.webScene) {
            this.format = "aura";
            if (this.webScene["format_exporter_version"]) {
                this.formatVersion = Number(this.webScene["format_exporter_version"].replace(new RegExp("\\.", "g"), "") + "0");
            }
            else {
                this.formatVersion = 1000;
            }
            if (this.formatVersion > 1000) {
                this.name = this.webScene["name"];
            }
            else {
                this.name = "unknown";
            }
        }
        try {
            for (var _b = __values(this.meshList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mesh = _c.value;
                mesh.renderingGroupId = 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Object.defineProperty(VFModel.prototype, "totalFileSize", {
        get: function () {
            return this.textureFileSize + this.modelFileSize;
        },
        enumerable: true,
        configurable: true
    });
    VFModel.prototype.getRoot = function () {
        return this.root;
    };
    VFModel.prototype.getContentRoot = function () {
        return this.contentRoot;
    };
    Object.defineProperty(VFModel.prototype, "properties", {
        get: function () {
            return this.webScene;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFModel.prototype, "hasProperties", {
        get: function () {
            return this.webScene != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFModel.prototype, "hasLightmaps", {
        get: function () {
            return this.webScene != null && this.properties["lightmaps"] != null;
        },
        enumerable: true,
        configurable: true
    });
    VFModel.prototype.panningEnabled = function () {
        if (!this.hasProperties) {
            return false;
        }
        if (!this.webScene["scene"]) {
            return false;
        }
        var panMode = this.webScene["scene"]["pan_mode"];
        logger_1.default.debug("Pan Mode: " + panMode);
        return panMode !== "DEFAULT";
    };
    VFModel.prototype.getMeshes = function () {
        return this.meshList;
    };
    VFModel.prototype.getObjectAtPath = function (path) {
        var e_2, _a;
        if (!this.hasProperties) {
            return null;
        }
        if (this._objectsByPath[path]) {
            return this._objectsByPath[path];
        }
        var objects = this.properties["objects"];
        if (!objects) {
            return null;
        }
        if (objects.constructor == Object && this.formatVersion < 1100) {
            for (var key in objects) {
                var obj = { path: key, name: objects[key] };
                if (this.comparePathWithInaccuracy(path, obj)) {
                    return this.comparePathWithInaccuracy(path, obj);
                }
            }
        }
        else {
            try {
                for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
                    var obj = objects_1_1.value;
                    if (this.comparePathWithInaccuracy(path, obj)) {
                        return this.comparePathWithInaccuracy(path, obj);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return null;
    };
    VFModel.prototype.getLightmapForObjectAt = function (path) {
        var e_3, _a, e_4, _b;
        if (!this.hasProperties) {
            return null;
        }
        var lightmaps = this.properties["lightmaps"];
        if (!lightmaps) {
            return null;
        }
        try {
            for (var lightmaps_1 = __values(lightmaps), lightmaps_1_1 = lightmaps_1.next(); !lightmaps_1_1.done; lightmaps_1_1 = lightmaps_1.next()) {
                var lm = lightmaps_1_1.value;
                var objects = lm["objects"];
                try {
                    for (var objects_2 = (e_4 = void 0, __values(objects)), objects_2_1 = objects_2.next(); !objects_2_1.done; objects_2_1 = objects_2.next()) {
                        var obj = objects_2_1.value;
                        if (path === path) {
                            return {
                                name: lm["name"],
                                uvs: obj["uvs"],
                            };
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (objects_2_1 && !objects_2_1.done && (_b = objects_2.return)) _b.call(objects_2);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (lightmaps_1_1 && !lightmaps_1_1.done && (_a = lightmaps_1.return)) _a.call(lightmaps_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return null;
    };
    VFModel.prototype.getMaterialForName = function (name) {
        var e_5, _a;
        if (!this.hasProperties) {
            return null;
        }
        if (this._materialsByName[name]) {
            return this._materialsByName[name];
        }
        var materials = this.properties["materials"];
        try {
            for (var materials_1 = __values(materials), materials_1_1 = materials_1.next(); !materials_1_1.done; materials_1_1 = materials_1.next()) {
                var mat = materials_1_1.value;
                if (name === mat["name"]) {
                    this._materialsByName[name] = mat;
                    return mat;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (materials_1_1 && !materials_1_1.done && (_a = materials_1.return)) _a.call(materials_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return null;
    };
    VFModel.prototype.getMaterialForHash = function (hash) {
        var e_6, _a;
        var materials = this.properties["materials"];
        try {
            for (var materials_2 = __values(materials), materials_2_1 = materials_2.next(); !materials_2_1.done; materials_2_1 = materials_2.next()) {
                var mat = materials_2_1.value;
                if (hash.toString() === mat["hash"].toString()) {
                    return mat;
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (materials_2_1 && !materials_2_1.done && (_a = materials_2.return)) _a.call(materials_2);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return null;
    };
    VFModel.prototype.getObjectForHash = function (hash) {
        var e_7, _a;
        var objects = this.properties["objects"];
        try {
            for (var objects_3 = __values(objects), objects_3_1 = objects_3.next(); !objects_3_1.done; objects_3_1 = objects_3.next()) {
                var obj = objects_3_1.value;
                if (hash.toString() === obj["hash"].toString()) {
                    return obj;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (objects_3_1 && !objects_3_1.done && (_a = objects_3.return)) _a.call(objects_3);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return null;
    };
    VFModel.prototype.findTextureNameForHash = function (hash) {
        var id = Number(hash);
        if (!this.properties["textures"]) {
            return null;
        }
        return this.properties["textures"][id];
    };
    VFModel.prototype.scaleToSize = function (targetScale) {
        var hierarchyBoundingVectors = this.root.getHierarchyBoundingVectors();
        var fixedBounds = new babylonjs_1.BoundingInfo(hierarchyBoundingVectors.min, hierarchyBoundingVectors.max);
        this.root.setBoundingInfo(fixedBounds);
        this.size = hierarchyBoundingVectors.max.subtract(hierarchyBoundingVectors.min);
        this.largestSize = Math.max(this.size.x, this.size.y, this.size.z);
        var meshDimensions = fixedBounds.boundingSphere.radiusWorld * 2;
        this.scaleFactor = targetScale / meshDimensions;
        this.root.scaling = this.root.scaling.scaleInPlace(this.scaleFactor);
        this.root.computeWorldMatrix(true);
        this.root.refreshBoundingInfo();
    };
    VFModel.prototype.scaleToBounds = function () {
        var hierarchyBoundingVectors = this.root.getHierarchyBoundingVectors();
        var fixedBounds = new babylonjs_1.BoundingInfo(hierarchyBoundingVectors.min, hierarchyBoundingVectors.max);
        this.root.setBoundingInfo(fixedBounds);
        this.size = hierarchyBoundingVectors.max.subtract(hierarchyBoundingVectors.min);
        var meshDimensions = fixedBounds.boundingSphere.radiusWorld * 2;
        this.largestSize = meshDimensions;
        this.root.computeWorldMatrix(true);
        this.root.refreshBoundingInfo();
    };
    VFModel.prototype.setOrigin = function (position) {
        this.root.setAbsolutePosition(position);
        var offsetY = position.y - this.root.getBoundingInfo().boundingBox.minimumWorld.y;
        this.root.position.addInPlace(new babylonjs_1.Vector3(0, offsetY, 0));
    };
    VFModel.prototype.getCenter = function () {
        var boundingSphere = this.root.getBoundingInfo().boundingSphere;
        return boundingSphere.centerWorld;
    };
    VFModel.prototype.comparePathWithInaccuracy = function (path, obj) {
        var objPath = obj["path"] + obj["name"];
        if (vf_tools_1.default.comparePathWithInaccuracy(path, objPath, 2)) {
            this._objectsByPath[path] = obj;
            return obj;
        }
    };
    VFModel.prototype.freeze = function () {
        var e_8, _a;
        logger_1.default.debug("model.freeze()");
        try {
            for (var _b = __values(this.meshList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mesh = _c.value;
                mesh.freezeWorldMatrix();
                mesh.doNotSyncBoundingInfo = true;
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    VFModel.prototype.unfreeze = function () {
        var e_9, _a;
        logger_1.default.debug("model.unfreeze()");
        try {
            for (var _b = __values(this.meshList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mesh = _c.value;
                mesh.unfreezeWorldMatrix();
                mesh.doNotSyncBoundingInfo = false;
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
    };
    VFModel.prototype.dispose = function () {
        var e_10, _a;
        try {
            for (var _b = __values(this.root.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var node = _c.value;
                node.dispose();
                if (node instanceof babylonjs_1.AbstractMesh && node.material) {
                    node.material.dispose();
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        this.root.dispose();
        this.root = null;
    };
    return VFModel;
}());
exports.default = VFModel;
